import { isValidBasePrice } from '@acme/b2b/pricing';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ensureArray } from '@b2b/common/utils/coerce-array';
import { SalesChannelType, TODO } from '@b2b/types/core';
import uiRouter from '@uirouter/angularjs';
import angular, { IScope } from 'angular';
import { CurrentPrice, CurrentPriceList } from '../types';

export const PricingListsEditControllerModule = angular
  .module('acme.view.application.pricing.lists.edit.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.validate',
    'acme.common.service.themesHelper',
  ])
  .controller('PricingListsEditController', [
    '$scope',
    'HelpersService',
    'ApiService',
    'CalendarService',
    'ValidateService',
    'ThemesHelperService',
    function PricingListsEditController(
      $scope: IScope & { pricingListsEdit: TODO },
      HelpersService: TODO,
      ApiService: ApiService,
      CalendarService: CalendarService,
      ValidateService: TODO,
      ThemesHelperService: ThemesHelperService
    ) {
      const ctrl = {
        editTitle: true,
        isCreated: false,
        isLoaded: false,
        isSubmitted: false,
        createPanelShown: false,
        enableSalesTax: false,

        selectedPrice: '' as string | null,
        selectedBasePrice: '' as string | null,
        selectedDescription: '',
        selectedAdmissionCategory: {} as TODO,
        currentAdmissionType: 'Individual',

        currentPriceIndex: 0,
        currentCategories: [],

        currentPrice: {
          personType: {
            name: '',
            description: '',
            active: true,
            type: 'Individual',
            defaultPrice: null,
          },
          salesChannels: [],
          price: null,
          basePrice: null,
          primePrice: null,
        } as CurrentPrice,

        model: {
          name: '',
          description: '',
          effectiveStartTime: CalendarService.toISO8601(new Date()),
          effectiveEndTime: null,
          prices: [],
        } as CurrentPriceList,

        salesChannels: [
          {
            channel: 'online',
            name: 'Online',
            enabled: true,
          },
          {
            channel: 'pointOfSale',
            name: 'Point of Sale',
            enabled: true,
          },
          {
            channel: 'reseller',
            name: 'Reseller',
            enabled: true,
          },
          {
            channel: 'customerRep',
            name: 'Customer Rep.',
            enabled: true,
          },
          {
            channel: 'kiosk',
            name: 'Kiosk',
            enabled: false,
          },
        ] as { channel: SalesChannelType; name: string; enabled: boolean }[],

        categories: {
          individual: [],
          combo: [],
        },

        init: function () {
          ctrl.enableSalesTax = ThemesHelperService.getFeatureFlag('enableSalesTax');

          $scope.$watchCollection('pricingListsEdit.currentAdmissionType', ctrl.onAdmissionTypeUpdate);

          ctrl.getCurrentGroupCategories();
        },

        updatePrice: function () {
          if (ctrl.selectedAdmissionCategory) {
            ctrl.currentPrice.personType = ctrl.selectedAdmissionCategory;
            ctrl.selectedPrice = ctrl.currentPrice.personType.defaultPrice;
            ctrl.selectedBasePrice = ctrl.currentPrice.basePrice;
            ctrl.selectedDescription = ctrl.currentPrice.personType.description;
          } else {
            ctrl.selectedPrice = '';
            ctrl.selectedBasePrice = null;
            ctrl.selectedDescription = '';
            ctrl.selectedAdmissionCategory = '';
          }
        },

        hasPrices: function () {
          return ctrl.model.prices;
        },

        addPrice: function () {
          ctrl.model.prices = ensureArray(ctrl.model.prices);

          ctrl.currentPrice.price = angular.copy(ctrl.selectedPrice);
          ctrl.currentPrice.basePrice = angular.copy(ctrl.selectedBasePrice);
          ctrl.currentPrice.personType = angular.copy(ctrl.selectedAdmissionCategory);
          ctrl.currentPrice.personType.type = angular.copy(ctrl.currentAdmissionType);
          ctrl.currentPrice.personType.description = angular.copy(ctrl.selectedDescription);
          ctrl.currentPrice.salesChannels = angular.copy(ctrl.salesChannels);

          /**
           * kiosk must be disabled by default
           */
          for (const salesChannel of ctrl.currentPrice.salesChannels) {
            if (salesChannel.channel === 'kiosk') {
              salesChannel.enabled = false;
            }
          }

          if (ctrl.isValidCurrentPrice()) {
            $scope.$emit('PricingListsEditController::addPrice', { price: angular.copy(ctrl.currentPrice) });
            ctrl.selectedAdmissionCategory = '';
            ctrl.updatePrice();
          }
        },

        getCurrentGroupCategories: function () {
          const type = ctrl.currentAdmissionType.toLowerCase();

          if (ctrl.categories[type].length === 0) {
            ApiService.price.types
              .list({
                ...HelpersService.getPaginator(),
                types: type === 'combo' ? 'combo' : 'normal',
              })
              .then((response) => ctrl.success.getCurrentGroupCategories(response))
              .catch((response) => ctrl.error.getCurrentGroupCategories(response));
          } else {
            ctrl.currentCategories = ctrl.categories[type].slice(0);
            ctrl.selectedAdmissionCategory = '';
            ctrl.updatePrice();
          }
        },

        isValidCurrentPrice: function () {
          return ValidateService.validate([
            {
              greater: {
                greater: ctrl.selectedPrice,
                less: -1,
              },
            },
          ]);
        },

        isValidCurrentBasePrice: function () {
          return isValidBasePrice({ basePrice: ctrl.selectedBasePrice, price: ctrl.selectedPrice });
        },

        success: {
          addPrice: function (response) {},

          getCurrentGroupCategories: function (response) {
            if (response.data.payload.list.length > 0) {
              const categoryType = response.data.payload.list[0].type;
              $scope.pricingListsEdit.categories[categoryType.toLowerCase()] = response.data.payload.list;
              $scope.pricingListsEdit.currentCategories = response.data.payload.list;
              $scope.pricingListsEdit.updatePrice();
            }
            $scope.pricingListsEdit.isLoaded = true;
            $scope.$emit('AppController::endLoad');
          },
        },

        error: {
          getCurrentGroupCategories: function (response) {
            //TODO: Need to handle this
          },
        },

        onAdmissionTypeUpdate: function (o, n) {
          if (n !== o) {
            $scope.pricingListsEdit.getCurrentGroupCategories();
          }
        },
      };

      $scope.pricingListsEdit = ctrl;
      ctrl.init();
    },
  ]).name;
